import React from 'react'
import PropTypes from 'prop-types'
import identity from 'lodash/identity'
import { useHandler, useIsFormSectionDisabled, useFormError, useFormSectionPath, useFormState } from 'src/hooks'
import { ErrorTooltip } from '../tooltips'

function getDefaultValue(type) {
  switch (type) {
    case 'checkbox':
      return false
    default:
      return ''
  }
}

function getCheckedProp(type, inputValue, fieldValue) {
  switch (type) {
    case 'checkbox':
      return fieldValue
    case 'radio':
      return inputValue === fieldValue
    default:
      return false
  }
}

export default function Field({
  component: Component,
  name,
  onChange,
  type,
  defaultValue = getDefaultValue(type),
  disabled,
  ...props
}) {
  // get relative path
  const path = useFormSectionPath(name)
  // get field value
  const [value, setValue] = useFormState(path, defaultValue)
  // get field error
  const error = useFormError(path)
  // render input
  return (
    <ErrorTooltip error={props.hasOwnProperty('error') ? props.error : error}>
      <Component
        value={value}
        name={name}
        error={props.hasOwnProperty('error') ? props.error : error}
        type={type}
        checked={getCheckedProp(type, props.value, value)}
        onChange={useHandler(event => setValue(onChange(event)))}
        disabled={useIsFormSectionDisabled() || disabled}
        {...props}
      />
    </ErrorTooltip>
  )
}

Field.propTypes = {
  name: PropTypes.string.isRequired,
  component: PropTypes.elementType.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string,
  error: PropTypes.string,
  defaultValue: PropTypes.any,
  type: PropTypes.string,
  disabled: PropTypes.bool,
}

Field.defaultProps = {
  onChange: identity,
}
